import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
//  import EventHub from './EventHub'
import lodash from 'lodash'
//import vSelect from 'vue-select'
import { Dropdown } from 'bootstrap-vue/es/components'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueAdsense from "vue-adsense";

// Google Adsense ?
Vue.component("adsense", VueAdsense);

Vue.use(VueRouter)
Vue.use(Dropdown)

//  Components

//  The Vue build version to load with the `import` command
//  (runtime-only or standalone) has been set in webpack.base.conf with an alias.

Vue.config.productionTip = false

//Filter
Vue.filter('truncate', function(value, length, omission) {
  var length = length ? parseInt(length, 10) : 20;
  var ommision = omission ? omission.toString() : '...';

  if(value.length <= length) {
    return value;
  }
  else {
    return value.substring(0, length) + ommision;
  }
})

Vue.filter('yen', function(value) {
  var num = Number(value)
  return num.toLocaleString() + '円'
})

/* eslint-disable no-new */

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: routes,
  mode: 'history',
  base: '/search/'

})

window.app = new Vue({
  router
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js